function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".DatamachineWorkbench-1{fill:#4b7dbf;}.DatamachineWorkbench-2{fill:none;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "DatamachineWorkbench-1",
  d: "M7.47,13.59H26A39.79,39.79,0,0,1,39.1,15.7a32.17,32.17,0,0,1,10.62,6.08,28.26,28.26,0,0,1,7.16,9.67,31,31,0,0,1,2.61,13,38,38,0,0,1-2.34,13.9,26.42,26.42,0,0,1-6.66,10,28,28,0,0,1-10.53,6,44.87,44.87,0,0,1-13.95,2H7.47Zm9,54.9h9.45q11.61,0,17.82-5.76T50,44.82A25.88,25.88,0,0,0,48.19,35,20.69,20.69,0,0,0,36,23.08a25.67,25.67,0,0,0-9-1.57H16.47Z",
  transform: "translate(-7.47 -12.51)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "DatamachineWorkbench-1",
  d: "M92.88,13.59h9.45l26.55,62.82h-9.81l-6.39-15.84H81.9L75.51,76.41H66.06Zm4.41,8.46L84.78,53.19h25Z",
  transform: "translate(-7.47 -12.51)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "DatamachineWorkbench-1",
  d: "M143.82,21.51H124.29V13.59h48.06v7.92H152.82v54.9h-9Z",
  transform: "translate(-7.47 -12.51)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "DatamachineWorkbench-1",
  d: "M196.29,13.59h9.45l26.55,62.82h-9.81l-6.39-15.84H185.31l-6.39,15.84h-9.45Zm4.41,8.46L188.19,53.19h25Z",
  transform: "translate(-7.47 -12.51)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "DatamachineWorkbench-1",
  d: "M241.47,13.59h14.85L276,65.79l19.35-52.2h14.85V76.41h-9V22.05h-.18L280.26,76.41h-8.82L250.65,22.05h-.18V76.41h-9Z",
  transform: "translate(-7.47 -12.51)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "DatamachineWorkbench-1",
  d: "M346.23,13.59h9.45l26.55,62.82h-9.81L366,60.57H335.25l-6.39,15.84h-9.45Zm4.41,8.46L338.13,53.19h25Z",
  transform: "translate(-7.47 -12.51)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "DatamachineWorkbench-1",
  d: "M434.69,23.94a25,25,0,0,0-13-3.51,25.68,25.68,0,0,0-9.85,1.84,22.88,22.88,0,0,0-7.65,5.13,22.59,22.59,0,0,0-4.91,7.79A27.4,27.4,0,0,0,397.61,45a26.35,26.35,0,0,0,1.85,10.08,23.3,23.3,0,0,0,5.08,7.74,22.6,22.6,0,0,0,7.56,5,24.16,24.16,0,0,0,9.18,1.76,28.54,28.54,0,0,0,3.6-.23,36,36,0,0,0,3.74-.63c1.23-.27,2.4-.58,3.51-.94A13.12,13.12,0,0,0,435,66.51l.54,8.73a25,25,0,0,1-7.56,1.89q-4,.36-6.75.36a38.44,38.44,0,0,1-13.59-2.3,29.06,29.06,0,0,1-10.44-6.57,29.43,29.43,0,0,1-6.7-10.35,36.76,36.76,0,0,1-2.39-13.54,34.09,34.09,0,0,1,2.48-13.23,29.46,29.46,0,0,1,6.93-10.17A31,31,0,0,1,408,14.8a37.24,37.24,0,0,1,13.27-2.29,44.85,44.85,0,0,1,7.2.58,28.79,28.79,0,0,1,6.93,2.12Z",
  transform: "translate(-7.47 -12.51)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "DatamachineWorkbench-1",
  d: "M446.75,13.59h9V39.87h30.06V13.59h9V76.41h-9V47.79H455.75V76.41h-9Z",
  transform: "translate(-7.47 -12.51)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "DatamachineWorkbench-1",
  d: "M511.28,13.59h9V76.41h-9Z",
  transform: "translate(-7.47 -12.51)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "DatamachineWorkbench-1",
  d: "M536.21,13.59h12.24l27.72,50.58h.18V13.59h9V76.41H573.83L545.39,24.75h-.18V76.41h-9Z",
  transform: "translate(-7.47 -12.51)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "DatamachineWorkbench-1",
  d: "M601.73,13.59h35.19v7.92H610.73V39.87h23.85v7.92H610.73v20.7h26.19v7.92H601.73Z",
  transform: "translate(-7.47 -12.51)"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "DatamachineWorkbench-1",
  d: "M39.33,121.59h9.9l15,53.82h.18l13.41-53.82H90.63l13.59,53.82h.18l15-53.82H129l-19.35,62.82H98l-13.68-54.9h-.18l-13.77,54.9H58.32Z",
  transform: "translate(-7.47 -12.51)"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "DatamachineWorkbench-1",
  d: "M135.94,140a29,29,0,0,1,5.94-10.26,28.08,28.08,0,0,1,9.5-6.8,34.17,34.17,0,0,1,25.51,0,28,28,0,0,1,9.54,6.8A29,29,0,0,1,192.37,140a39.93,39.93,0,0,1,2,13,40.52,40.52,0,0,1-2,13.14,29.37,29.37,0,0,1-5.89,10.26,26.26,26.26,0,0,1-9.5,6.7,35.61,35.61,0,0,1-25.65,0,26.22,26.22,0,0,1-9.49-6.7,29.39,29.39,0,0,1-5.9-10.26,40.52,40.52,0,0,1-2-13.14A39.93,39.93,0,0,1,135.94,140Zm8.73,22.05a24.06,24.06,0,0,0,3.74,7.87,18.55,18.55,0,0,0,6.43,5.54,22,22,0,0,0,18.63,0,18.59,18.59,0,0,0,6.44-5.54,24,24,0,0,0,3.73-7.87,34.07,34.07,0,0,0,1.22-9.09,32.68,32.68,0,0,0-1.31-9.23,24.41,24.41,0,0,0-3.87-7.87,18.86,18.86,0,0,0-6.43-5.45,21.46,21.46,0,0,0-18.18,0,18.89,18.89,0,0,0-6.44,5.45,24.41,24.41,0,0,0-3.87,7.87,32.68,32.68,0,0,0-1.3,9.23A34.06,34.06,0,0,0,144.67,162.09Z",
  transform: "translate(-7.47 -12.51)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "DatamachineWorkbench-1",
  d: "M206.64,121.59H222a73.56,73.56,0,0,1,9,.54,22.53,22.53,0,0,1,7.79,2.34,14.09,14.09,0,0,1,5.49,5.13q2.07,3.33,2.07,9a13.94,13.94,0,0,1-1,5.31,13.44,13.44,0,0,1-2.75,4.27,15,15,0,0,1-4.14,3.06,17.43,17.43,0,0,1-5.08,1.67v.18a9.34,9.34,0,0,1,3.33,2.11,19.47,19.47,0,0,1,2.79,4.19l11.88,25H241.2l-9.63-21.78a16.26,16.26,0,0,0-2.16-3.51,7.13,7.13,0,0,0-2.34-1.85,7.77,7.77,0,0,0-2.75-.67c-1-.06-2.08-.09-3.28-.09h-5.4v27.9h-9Zm9,27h7.65q6.48,0,10-2.61a8.44,8.44,0,0,0,3.56-7.2,8.15,8.15,0,0,0-3.2-6.8q-3.19-2.47-9.4-2.47h-8.64Z",
  transform: "translate(-7.47 -12.51)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "DatamachineWorkbench-1",
  d: "M262.62,121.59h9v27.63l26.82-27.63h12l-29.52,29.7,31.86,33.12H299.61l-28-30.78v30.78h-9Z",
  transform: "translate(-7.47 -12.51)"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "DatamachineWorkbench-1",
  d: "M321.66,121.59h17a44.53,44.53,0,0,1,8.95.85,20.31,20.31,0,0,1,7,2.75,13.31,13.31,0,0,1,4.5,4.9,15.37,15.37,0,0,1,1.62,7.34q0,6.48-3.51,9.94a20.28,20.28,0,0,1-9.45,5v.18a18.26,18.26,0,0,1,5.89,1.44,15.1,15.1,0,0,1,4.59,3.1,13.94,13.94,0,0,1,3,4.59A18,18,0,0,1,360.4,176a14.27,14.27,0,0,1-5.22,5.13,22.58,22.58,0,0,1-7.65,2.61,56,56,0,0,1-9.13.72H321.66Zm9,26.82h4.95q3.24,0,6.16-.27a15.33,15.33,0,0,0,5.13-1.31,8.3,8.3,0,0,0,3.51-3,9.9,9.9,0,0,0,1.31-5.49,8.81,8.81,0,0,0-1.08-4.59,8.55,8.55,0,0,0-2.79-2.88,11,11,0,0,0-3.74-1.49,20.32,20.32,0,0,0-4-.4h-9.45Zm0,28.62h6.75a40.7,40.7,0,0,0,5.85-.41,14.68,14.68,0,0,0,4.9-1.53,8.78,8.78,0,0,0,3.38-3.1,9.42,9.42,0,0,0,1.26-5.13,10.51,10.51,0,0,0-1.44-5.81,9.52,9.52,0,0,0-3.78-3.37,16.1,16.1,0,0,0-5.27-1.53,47.4,47.4,0,0,0-5.8-.36h-5.85Z",
  transform: "translate(-7.47 -12.51)"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "DatamachineWorkbench-1",
  d: "M377.64,121.59h35.19v7.92H386.64v18.36h23.85v7.92H386.64v20.7h26.19v7.92H377.64Z",
  transform: "translate(-7.47 -12.51)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "DatamachineWorkbench-1",
  d: "M427.14,121.59h12.24l27.72,50.58h.18V121.59h9v62.82H464.76l-28.44-51.66h-.18v51.66h-9Z",
  transform: "translate(-7.47 -12.51)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "DatamachineWorkbench-1",
  d: "M535.58,131.94a25,25,0,0,0-13-3.51,25.71,25.71,0,0,0-9.85,1.84,22.88,22.88,0,0,0-7.65,5.13,22.59,22.59,0,0,0-4.91,7.79A27.4,27.4,0,0,0,498.5,153a26.35,26.35,0,0,0,1.85,10.08,23.32,23.32,0,0,0,5.09,7.74,22.55,22.55,0,0,0,7.55,5,24.21,24.21,0,0,0,9.19,1.76,28.66,28.66,0,0,0,3.6-.23,36.29,36.29,0,0,0,3.73-.63c1.23-.27,2.4-.58,3.51-.94a13.44,13.44,0,0,0,2.84-1.26l.54,8.73a25.13,25.13,0,0,1-7.57,1.89q-4,.36-6.75.36a38.44,38.44,0,0,1-13.59-2.3,29,29,0,0,1-10.43-6.57,29.45,29.45,0,0,1-6.71-10.35A36.76,36.76,0,0,1,489,152.73a34.09,34.09,0,0,1,2.48-13.23,29.46,29.46,0,0,1,6.93-10.17,31,31,0,0,1,10.53-6.53,37.26,37.26,0,0,1,13.28-2.29,44.82,44.82,0,0,1,7.19.58,29,29,0,0,1,6.94,2.12Z",
  transform: "translate(-7.47 -12.51)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "DatamachineWorkbench-1",
  d: "M547.64,121.59h9v26.28H586.7V121.59h9v62.82h-9V155.79H556.64v28.62h-9Z",
  transform: "translate(-7.47 -12.51)"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "DatamachineWorkbench-2",
  d: "M251.66,148.38c0,77.38,122.1,140,273,140",
  transform: "translate(-7.47 -12.51)"
});

var SvgDatamachineWorkbench = function SvgDatamachineWorkbench(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "DatamachineWorkbench_1",
    "data-name": "DatamachineWorkbench 1",
    viewBox: "0 -50 629.45 275.87",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDatamachineWorkbench, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DatamachineWorkbench.4f63e874.svg";
export { ForwardRef as ReactComponent };